var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/698e7a3e503f0627532b181b0b5e941e.js').default;export default
        Object.assign({}, scope_0 )
    